export enum ParentBehaviour {
  SelectAll = 'selectAll',
  ShowChildrenOnSelect = 'showChildrenOnSelect',
  AllowParentSelect = 'allowParentSelect',
}
